var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.299 6.70096C13.8448 8.24679 13.8448 10.7531 12.299 12.2989M14.5382 4.46174C17.3207 7.24423 17.3207 11.7555 14.5382 14.538M4.42208 11.875H3.16667C2.72944 11.875 2.375 11.5205 2.375 11.0833V7.91663C2.375 7.4794 2.72944 7.12496 3.16667 7.12496H4.42208L8.14854 3.3985C8.64726 2.89978 9.5 3.25299 9.5 3.95829V15.0416C9.5 15.7469 8.64726 16.1001 8.14854 15.6014L4.42208 11.875Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakers);
export default __webpack_public_path__ + "static/media/speakers.2c5285c078577dcfcf6eb433eb80f346.svg";
export { ForwardRef as ReactComponent };